var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRoot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_201",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 201",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10048",
    "data-name": "\\u9577\\u65B9\\u5F62 10048",
    width: 24,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16739",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16739",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13059",
    "data-name": "\\u30D1\\u30B9 13059",
    d: "M0,0H24.119V24.119H0Z",
    transform: "translate(0 -0.079)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-route",
    d: "M23.277,10.387l-9.6-9.6A2.313,2.313,0,0,0,10.409.7c-.03.029-.06.058-.088.088l-9.6,9.6a2.313,2.313,0,0,0-.088,3.271c.029.03.058.06.088.088l9.6,9.6a2.315,2.315,0,0,0,3.272.088c.029-.029.059-.058.087-.088l9.6-9.6a2.313,2.313,0,0,0,.088-3.271C23.336,10.444,23.308,10.414,23.277,10.387ZM14.4,15.064v-3H9.6v3.6H7.2v-3.6a2.4,2.4,0,0,1,2.4-2.4h4.8v-3l4.2,4.2Z",
    transform: "translate(0 -0.066)",
    fill: "#676767"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoot);
export default __webpack_public_path__ + "static/media/icon_root.0ea4e7e43e4481e2d0f90d50b0fefb9e.svg";
export { ForwardRef as ReactComponent };